// Must match SearchPagePublisher.toSlug() in Botimza/server/services/SearchPagePublisher.js -
// any client-side link into /search/{slug} has to produce the exact slug the server publishes
// under, or the Worker's KV lookup misses and falls back to a 302 redirect.
export function toSlug(term) {
  return String(term || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}
